import { render, staticRenderFns } from "./transcriptView.component.vue?vue&type=template&id=5925a3a6&scoped=true&"
import script from "./transcriptView.component.vue?vue&type=script&lang=js&"
export * from "./transcriptView.component.vue?vue&type=script&lang=js&"
import style0 from "./transcriptView.component.vue?vue&type=style&index=0&id=5925a3a6&lang=scss&scoped=true&"
import style1 from "./transcriptView.component.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5925a3a6",
  null
  
)

export default component.exports